import DOMPurify from '../utils/purify.min.js';

// The formatting the questionnaire builder allows: inline emphasis, line
// breaks, paragraphs, lists, links, and the custom qr-code element (rendered
// as a scannable QR code generated from its value attribute). Everything else
// is stripped on both write and render. Mirrors
// Questionnaires::SaveDefinitionService::ALLOWED_RICH_TAGS.
const ALLOWED_TAGS = ['b', 'strong', 'u', 'br', 'a', 'em', 'i', 'p', 'ul', 'ol', 'li', 'qr-code'];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'value'];

const RICH_TAG_PATTERN = /<(b|strong|u|br|a|em|i|p|ul|ol|li|qr-code)\b/i;

// contentEditable browsers often wrap new lines in block elements; convert those
// to <br> before sanitizing so line breaks are not lost when div tags are
// stripped.
export const normalizeRichHtml = (value) => {
  const html = value == null ? '' : String(value);
  if (!html) return '';

  return html.replace(/<div[^>]*>/gi, '<br>').replace(/<\/div>/gi, '');
};

export const sanitizeRichText = (value) => {
  const sanitized = DOMPurify.sanitize(normalizeRichHtml(value), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
  // For security, ensure links that open a new tab cannot access the opener.
  // Force rel=\"noopener noreferrer\" on any anchor with target=\"_blank\".
  return sanitized.replace(
    /<a\b([^>]*\btarget\s*=\s*(['\"])_blank\2[^>]*)>/gi,
    (tag) => {
      if (/\brel\s*=/.test(tag)) {
        return tag.replace(/\brel\s*=\s*(['\"]).*?\1/i, 'rel="noopener noreferrer"');
      }
      return tag.replace(/>$/, ' rel="noopener noreferrer">');
    }
  );
};

// True when the value actually contains one of the allowed formatting tags.
// Lets callers keep treating plain, legacy content as a plain string.
export const hasRichFormatting = (value) => RICH_TAG_PATTERN.test(value == null ? '' : String(value));

// True when the sanitized value contains a qr-code element, which the RichText
// component must render as a real QR code instead of injecting raw HTML.
export const hasQrCode = (value) => /<qr-code\b/i.test(value == null ? '' : String(value));
